<template>
  <div class="vertical-banner absolute right-0 top-0 bottom-0 flex">
    <img src="@/assets/images/bg/zr-vertical-text.svg" class="object-contain">
  </div>
</template>

<script>
export default {

}
</script>

<style>
.main-slide .right-column-inner {
  padding-right: 6.5rem;
}
.vertical-banner {
  width: 5.5rem;
  border-left: 2px solid #029dcc;
}
</style>